import React, { Component } from 'react';
import $ from 'jquery';
import * as requestLib from '../../lib/requestLib';

class GroupView extends Component {
	constructor(props) {
		super(props);

		this.state = {
			groupList: [],
			focusedGroup: '',
			comment: '',
			accessToken: '',
		};

		this.baseUrl = requestLib.getUrl();
	}

	getCookie(name) {
		let value = '; ' + document.cookie;
		let parts = value.split('; ' + name + '=');
		if (parts.length === 2) return parts.pop().split(';').shift();
	}

	findGroupNum(id) {
		let groupList = this.props.groupList;
		if (groupList) {
			for (let i = 0; i < groupList.length; i++) {
				if (id === groupList[i].groupId) {
					this.props.showToast(groupList[i].groupNo);
				}
			}
		}
	}


	addBookmark(value, e) {
		if (e.key === 'Enter') {
			let createdat = +new Date();
			$(this).addClass('active');
			let data;
			if (this.props.type == 'organism') {
                this.props.data.articles.forEach((v) => {
                    v.img = this.props.data.img;
                    v.sname = this.props.data.sname;
                    v.cname = this.props.data.cname;
                    v.class = this.props.data.class;
                    v.domain = this.props.domain;
                    v.compound_id = this.props.data.compound_ids;
                    v.createdat = createdat;
                    v.allId = this.props.id;
                });

                let list = [...this.props.data.articles];

                data = {
                    groupId: value.groupId,
                    userToken: this.props.token,
                    type: this.props.type,
                    data: list,
                    comment: this.state.comment,
                    identity: this.props.id,
                };

                $.ajax({
                    url: this.baseUrl + 'api/bookmark/addBookmarkAll',
                    data,
                    method: 'post',
                    dataType: 'json',
                    success: function (response) {
                        if (response.status) {
                            let commentData = {
                                groupId: value.groupId,
                                userToken: this.props.token,
                                comment: this.state.comment,
                                type: this.props.type,
                                identity: this.props.id,
                            };

                            $.ajax({
                                url:
                                    this.baseUrl +
                                    'api/bookmark/bookmarkAddComment',
                                data: commentData,
                                method: 'post',
                                dataType: 'json',
                                success: function (commentResponse) {
                                    this.findGroupNum(this.state.focusedGroup);

                                    this.setState({
                                        comment: '',
                                        focusedGroup: '',
                                    });
                                    this.props.setGroupViewState();
                                }.bind(this),
                                error: function (e) {}.bind(this),
                            });
                        }
                    }.bind(this),
                    error: function (e) {
                        console.log(e);
                    }.bind(this),
                });
            } else {
                let groupData = {
                    ...this.props.data,
                    img: this.props.img,
                    sname: this.props.sname,
                    cname: this.props.cname,
                    createdat,
                };
                data = {
                    groupId: value.groupId,
                    userToken: this.props.token,
                    type: this.props.type,
                    identity: this.props.id,
                    comment: this.state.comment,
                    data: groupData,
                };

                if (value.haveBookmark) {
                    this.props.alreadySavedAlert();
                } else {
                    $.ajax({
                        url: this.baseUrl + 'api/bookmark/addBookmark',
                        data: data,
                        method: 'post',
                        dataType: 'json',
                        success: function (response) {
                            if (response.status) {
                                let commentData = {
                                    groupId: value.groupId,
                                    userToken: this.props.token,
                                    comment: this.state.comment,
                                    type: this.props.type,
                                    identity: this.props.id,
                                };

                                $.ajax({
                                    url:
                                        this.baseUrl +
                                        'api/bookmark/bookmarkAddComment',
                                    data: commentData,
                                    method: 'post',
                                    dataType: 'json',
                                    success: function (commentResponse) {
                                        this.findGroupNum(
                                            this.state.focusedGroup,
                                        );

                                        this.setState({
                                            comment: '',
                                            focusedGroup: '',
                                        });
                                        this.props.setGroupViewState();
                                    }.bind(this),
                                    error: function (e) {}.bind(this),
                                });
                            }
                        }.bind(this),
                        error: function (e) {}.bind(this),
                    });
                }
            }
		}
	}


	showInput(value, e) {
		e.preventDefault();
		e.stopPropagation();
		this.setState({ comment: '' });
		if (!value.haveBookmark) {
			this.setState({ focusedGroup: value.groupId });
		}
	}

	render() {
		let groupList;
		groupList =
			this.props.groupList &&
			this.props.groupList.map((vv, kk) => {
				return (
                    <li
                        key={kk}
                        onClick={(e) => this.showInput(vv, e)}
                        className={
                            vv.haveBookmark
                                ? 'active'
                                : this.state.focusedGroup === vv.groupId
                                ? 'focus'
                                : ''
                        }
                        style={{
                            background: vv.haveBookmark ? '#e0e0e0' : '#fbfbfb',
                        }}
                    >
                        {vv.haveBookmark ? 'Added to' : 'Add to'}{' '}
                        <strong>{vv.name}</strong>
                        {this.state.focusedGroup === vv.groupId && (
                            <div>
                                <input
                                    placeholder="leave memo (optional)"
                                    value={this.state.comment}
                                    onChange={(e) =>
                                        this.setState({
                                            comment: e.target.value,
                                        })
                                    }
                                    onKeyDown={(e) => this.addBookmark(vv, e)}
                                    autoFocus={true}
                                />
                            </div>
                        )}
                    </li>
                );
			});

		let selectGroupView = (
			<div className="selectGroup">
				<p onMouseDown={() => this.props.createNewGroup(true, this.props.groupViewShow)}>+ Create a New Group</p>
				<ul>{groupList}</ul>
			</div>
		);

		return <div className="overlay">{selectGroupView}</div>;
	}
}
export default GroupView;



// WEBPACK FOOTER //
// ./src/components/Group/GroupView.jsx